// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"styles_switchContainer__1C0zx","switch":"styles_switch__2HJa9","slider":"styles_slider__2S2Xl"};